
import {NumberingScheme, UserGrid} from "@/user_grid_logic";
import {PropType, reactive} from "vue";
import PointInput from "@/components/PointInput.vue";

export default {
  components: {PointInput},
  props: {
    value: {
      type: Object as PropType<UserGrid>,
      required: true,
    }
  },
  emits: [
    "value-change",
  ],
  data() {
    const mutableValue = reactive(new UserGrid(this.value));
    return {
      mutableValue,
      hasQuadrantLetters: this.value.cellQuadrantLetters != null,
      NumberingScheme,
    }
  },
  watch: {
    mutableValue: {
      handler() {
        //todo validate first and last identifier of both axes
        //this.validateIdentifierValue(this.$refs.topLeftIdentifier, this.mutableValue.topLeftIdentifier);
        //this.validateIdentifierValue(this.$refs.bottomRightIdentifier, this.mutableValue.bottomRightIdentifier);
        this.validateIdentifierValue(this.$refs.refPoint0Identifier, this.mutableValue.refPoint0Identifier);
        this.validateIdentifierValue(this.$refs.refPoint1Identifier, this.mutableValue.refPoint1Identifier);
        this.$refs.form.checkValidity();
        this.$emit("value-change", this.mutableValue);
      },
      deep: true,
    },
    hasQuadrantLetters() {
      this.mutableValue.cellQuadrantLetters = this.$refs.inpQuadrantLettersActive.value
          ? ["A", "B", "C", "D"]
          : null;
    }
  },
  methods: {
    arrayElementsEllipsis(arr: string[]) {
      if (arr.length <= 10) {
        return arr.join(", ");
      } else {
        return [...arr.slice(0, 5), "...", ...arr.slice(arr.length - 5)].join(", ");
      }
    },
    validateIdentifierValue(element: HTMLInputElement, identifierValue: string) {
      element.setCustomValidity("");
      try {
        this.mutableValue.splitIdentifier(identifierValue);
      } catch (UserGridIdentifierFormatError) {
        element.setCustomValidity("Ungültig");
      }
    }
  },
  computed: {
    /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
    checkValues() {
      const values = {
        columnTitles: "",
        rowTitles: "",
        cellSize: "",
      }
      try {
        values.columnTitles = this.arrayElementsEllipsis(this.mutableValue.xAxis.getTitles());
        values.rowTitles = this.arrayElementsEllipsis(this.mutableValue.yAxis.getTitles());
      } catch (UserGridIdentifierFormatError) {
      }
      try {
        const cellSize = this.mutableValue.getCellSize();
        values.cellSize = cellSize != null ? Math.round(cellSize).toString() : "";
      } catch (UserGridIdentifierFormatError){
      }
      return values;
    },
  }
}
